import apiInstance from '../../apiInstance.js';
import widgetPreview from '../widgetPreview.js';

const tripadvisorPreview = async (widget) => {
    if (widget.isUrlChanged || widget.isReviewCountChanged) {
        var data = {
            error: '',
            fieldErrors: '',
            serveData: {},
            previewHtml: ''
        };
        var request_body = { widget };
        return apiInstance.post('/widget/preview/', request_body)
            .then(response => {
                let resData = response.data.data;
                const dataNeeded = {
                    name: widget.widgetTypeName,
                    title: widget.title,
                    htmlData: widget.htmlData,
                    script: widget.widgetTypeScripts,
                    content: resData.serveData,
                    isUrlChanged: widget.isUrlChanged,
                    isReviewCountChanged: widget.isReviewCountChanged,
                };
                widgetPreview(dataNeeded);

                return data;
            })
            .catch(error => {
                data.error = error;
                return data;
            });
    } else {
        const tripadvisorData = widget.htmlData.tripadvisor;
        const { header, layout, reviews, container, button, filters } = tripadvisorData;
        
        // Apply CSS variables
        var cssRoot = document.querySelector(':root');
        cssRoot.style.setProperty('--tripadvisor-header-display', header.showHeader ? 'flex' : 'none');
        cssRoot.style.setProperty('--tripadvisor-logo-display', header.showLogo ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-name-display', header.showCompanyName ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-total-reviews-display', header.showTotalReviews ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-rating-display', header.showRating ? 'flex' : 'none');
        cssRoot.style.setProperty('--tripadvisor-write-review-display', button.showWriteReview ? 'flex' : 'none');
        cssRoot.style.setProperty('--tripadvisor-review-photos-display', reviews.showReviewPhotos ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-trip-type-display', reviews.showTripType ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-review-date-display', reviews.showReviewDate ? 'block' : 'none');
        cssRoot.style.setProperty('--tripadvisor-logo-size', header.logoSize || '60px');
        cssRoot.style.setProperty('--tripadvisor-logo-alignment', header.logoAlignment || 'left');
        cssRoot.style.setProperty('--tripadvisor-name-font-family', header.companyNameFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-name-font-size', header.companyNameFontSize || '24px');
        cssRoot.style.setProperty('--tripadvisor-name-font-weight', header.companyNameFontBold || 'bold');
        cssRoot.style.setProperty('--tripadvisor-name-color', header.companyNameColor || '#333333');
        cssRoot.style.setProperty('--tripadvisor-total-reviews-font-family', header.totalReviewsFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-total-reviews-font-size', header.totalReviewsFontSize || '14px');
        cssRoot.style.setProperty('--tripadvisor-total-reviews-font-weight', header.totalReviewsFontBold || 'normal');
        cssRoot.style.setProperty('--tripadvisor-total-reviews-color', header.totalReviewsColor || '#666666');
        cssRoot.style.setProperty('--tripadvisor-header-bg', header.headerBackgroundColor || '#ffffff');
        cssRoot.style.setProperty('--tripadvisor-header-border-radius', header.headerBorderRadius || '8px');
        cssRoot.style.setProperty('--tripadvisor-rating-star-size', header.ratingStarSize || '20px');
        cssRoot.style.setProperty('--tripadvisor-rating-star-color', header.ratingStarColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-rating-star-empty-color', header.ratingStarEmptyColor || '#e5e5e5');
        cssRoot.style.setProperty('--tripadvisor-rating-number-color', header.ratingColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-rating-count-color', header.ratingCountColor || '#666666');
        cssRoot.style.setProperty('--tripadvisor-rating-font-family', header.ratingFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-rating-font-size', header.ratingFontSize || '16px');
        cssRoot.style.setProperty('--tripadvisor-rating-font-weight', header.ratingFontBold || 'bold');
        cssRoot.style.setProperty('--tripadvisor-column-count', layout.layoutType === 'masonry' ? '3' : layout.layoutType === 'carousel' ? 'auto' : '1');
        cssRoot.style.setProperty('--tripadvisor-column-gap', layout.columnGap || '10px');
        cssRoot.style.setProperty('--tripadvisor-sm-column-count', layout.layoutType === 'masonry' ? '2' : layout.layoutType === 'carousel' ? 'auto' : '1');
        cssRoot.style.setProperty('--tripadvisor-xs-column-count', layout.layoutType === 'masonry' ? '1' : layout.layoutType === 'carousel' ? 'auto' : '1');
        cssRoot.style.setProperty('--tripadvisor-reviewer-name-font-family', reviews.reviewerNameFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-reviewer-name-font-size', reviews.reviewerNameFontSize || '16px');
        cssRoot.style.setProperty('--tripadvisor-reviewer-name-font-weight', reviews.reviewerNameFontBold || 'bold');
        cssRoot.style.setProperty('--tripadvisor-reviewer-name-color', reviews.reviewerNameColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-reviewer-details-font-family', reviews.reviewerDetailsFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-reviewer-details-font-size', reviews.reviewerDetailsFontSize || '12px');
        cssRoot.style.setProperty('--tripadvisor-reviewer-details-color', reviews.reviewerDetailsColor || '#666666');
        cssRoot.style.setProperty('--tripadvisor-star-color', reviews.starColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-star-empty-color', reviews.starEmptyColor || '#cccccc');
        cssRoot.style.setProperty('--tripadvisor-star-size', reviews.starSize || '26px');
        cssRoot.style.setProperty('--tripadvisor-review-date-font-family', reviews.reviewDateFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-review-date-font-size', reviews.reviewDateFontSize || '12px');
        cssRoot.style.setProperty('--tripadvisor-review-date-font-weight', reviews.reviewDateFontWeight || 'normal');
        cssRoot.style.setProperty('--tripadvisor-review-date-color', reviews.reviewDateColor || '#666666');
        cssRoot.style.setProperty('--tripadvisor-review-title-font-family', reviews.reviewTitleFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-review-title-font-size', reviews.reviewTitleFontSize || '16px');
        cssRoot.style.setProperty('--tripadvisor-review-title-font-weight', reviews.reviewTitleFontBold || 'bold');
        cssRoot.style.setProperty('--tripadvisor-review-title-color', reviews.reviewTitleColor || '#333333');
        cssRoot.style.setProperty('--tripadvisor-review-text-font-family', reviews.reviewTextFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-review-text-font-size', reviews.reviewTextFontSize || '14px');
        cssRoot.style.setProperty('--tripadvisor-review-text-font-weight', reviews.reviewTextFontWeight || 'normal');
        cssRoot.style.setProperty('--tripadvisor-review-text-color', reviews.reviewTextColor || '#333333');
        cssRoot.style.setProperty('--tripadvisor-read-more-font-family', reviews.readMoreFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-read-more-font-size', reviews.readMoreFontSize || '12px');
        cssRoot.style.setProperty('--tripadvisor-read-more-font-weight', reviews.readMoreFontWeight || 'normal');
        cssRoot.style.setProperty('--tripadvisor-read-more-color', reviews.readMoreColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-read-more-hover-color', reviews.readMoreHoverColor || '#008055');
        cssRoot.style.setProperty('--tripadvisor-trip-type-font-family', reviews.tripTypeFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-trip-type-font-size', reviews.tripTypeFontSize || '12px');
        cssRoot.style.setProperty('--tripadvisor-trip-type-font-weight', reviews.tripTypeFontWeight || 'normal');
        cssRoot.style.setProperty('--tripadvisor-trip-type-color', reviews.tripTypeColor || '#666666');
        cssRoot.style.setProperty('--tripadvisor-review-bg', reviews.reviewBackgroundColor || '#ffffff');
        cssRoot.style.setProperty('--tripadvisor-review-border-color', reviews.reviewBorderColor || '#e0e0e0');
        cssRoot.style.setProperty('--tripadvisor-review-border-radius', reviews.reviewBorderRadius || '4px');
        cssRoot.style.setProperty('--tripadvisor-review-padding', reviews.reviewPadding || '10px');
        cssRoot.style.setProperty('--tripadvisor-review-min-height', reviews.reviewMinHeight || 'auto');
        cssRoot.style.setProperty('--tripadvisor-container-max-width', container.containerMaxWidth || '100%');
        cssRoot.style.setProperty('--tripadvisor-write-review-font-family', button.WriteReviewFontFamily || 'Arial, sans-serif');
        cssRoot.style.setProperty('--tripadvisor-write-review-font-size', button.WriteReviewFontSize || '14px');
        cssRoot.style.setProperty('--tripadvisor-write-review-font-weight', button.WriteReviewFontWeight || 'normal');
        cssRoot.style.setProperty('--tripadvisor-write-review-alignment', button.WriteReviewAlignment || 'left');
        cssRoot.style.setProperty('--tripadvisor-write-review-color', button.WriteReviewColor || '#ffffff');
        cssRoot.style.setProperty('--tripadvisor-write-review-bg', button.WriteReviewBackgroundColor || '#00aa6c');
        cssRoot.style.setProperty('--tripadvisor-write-review-hover-text-color', button.WriteReviewHoverTextColor || '#ffffff');
        cssRoot.style.setProperty('--tripadvisor-write-review-hover-bg', button.WriteReviewHoverBackgroundColor || '#008055');
        cssRoot.style.setProperty('--tripadvisor-write-review-padding', button.WriteReviewPadding || '10px 20px');
        cssRoot.style.setProperty('--tripadvisor-write-review-border-radius', button.WriteReviewBorderRadius || '4px');

        // Show all reviews
        const reviewsContainer = document.querySelector('.brta-all-reviews');
        if (reviewsContainer) {
            const reviews = reviewsContainer.querySelectorAll('.brta-single-review');
            const ratingFilter = filters?.numberOfRatings || 'all';
            const maxReviews = filters?.numberOfReviews === 'all' ? Infinity : parseInt(filters?.numberOfReviews) || 10;
            let displayCount = 0;
            
            reviews.forEach(review => {
                const rating = Number(review.getAttribute('data-rating')) || 0;
                const filterValue = ratingFilter === 'all' ? -1 : Number(ratingFilter);
                const display = (filterValue === -1 || rating >= filterValue) && displayCount < maxReviews;
                
                if (display) {
                    review.classList.remove('brtpmj-hidden');
                    review.classList.add('filtered');
                    displayCount++;
                } else {
                    review.classList.add('brtpmj-hidden');
                    review.classList.remove('filtered');
                }
            });
        }

        // Handle carousel resources
        var carouselStyle = document.getElementById('mjwi-style-carousel');
        var carouselScript = document.getElementById('mjwi-script-carousel');

        if (tripadvisorData.layout.layoutType === 'carousel') {
            // Ensure carousel CSS is loaded
            if (!carouselStyle) {
                carouselStyle = document.createElement('link');
                carouselStyle.href = window.mjFrontend + '/styles/carousel.css';
                carouselStyle.id = 'mjwi-style-carousel';
                carouselStyle.rel = 'stylesheet';
                carouselStyle.type = 'text/css';
                document.head.appendChild(carouselStyle);
            }

            // Ensure carousel script is loaded
            if (!carouselScript) {
                carouselScript = document.createElement('script');
                carouselScript.src = window.mjFrontend + '/scripts/carousel.js';
                carouselScript.type = 'text/javascript';
                carouselScript.id = 'mjwi-script-carousel';
                document.head.appendChild(carouselScript);
            }

            // Handle navigation buttons
            const wrapper = document.querySelector('.carousel-container');
            if (wrapper) {
                // Remove existing nav if any
                const existingNav = wrapper.querySelector('.carousel-nav');
                if (existingNav) {
                    existingNav.remove();
                }
                
                // Add new nav only if there are reviews
                const crsl_btn_html = `
                    <div class="carousel-nav">
                        <button class="mjwi-slider-btn mjwi-slider-prev" onclick="prevSlide()">❮</button>
                        <button class="mjwi-slider-btn mjwi-slider-next" onclick="nextSlide()">❯</button>
                    </div>`;
                wrapper.insertAdjacentHTML('beforeend', crsl_btn_html);
            }
        } else {
            // Clean up carousel resources if not needed
            if (carouselStyle) {
                carouselStyle.parentNode.removeChild(carouselStyle);
            }
            if (carouselScript) {
                carouselScript.parentNode.removeChild(carouselScript);
            }
            
            // Remove carousel nav if exists
            const element = document.querySelector('.carousel-nav');
            if (element) {
                element.remove();
            }

            // Reset transform for list/masonry layout
            const wrapper = document.querySelector('.brta-all-reviews');
            if (wrapper) {
                wrapper.style.transform = 'translateX(0)';
            }
        }
    }
};

export default tripadvisorPreview;